import { createContractRequest } from './helper';
export const putTextExtraction = createContractRequest({
    route: '/contract/offers/:offerId/textExtraction',
    method: 'put',
    source: 'data',
    contentType: 'multipart/form-data',
});
